import {Component, OnInit, Inject, ViewChild, OnDestroy} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {UploadFileComponent} from 'src/app/shared/components/upload-file/upload-file.component';
import {UploadMultiFileComponent} from '../upload-multi-file/upload-multi-file.component';
import {DataService} from '../../../core/services/data.service';

@Component({
  selector: 'app-test',
  templateUrl: './import-customer-file.component.html'
})
export class ImportCustomerFileComponent implements OnInit, OnDestroy {
  @ViewChild(UploadFileComponent, {read: UploadFileComponent, static: false}) uploadFileComponent;
  haveFileUpload = false;
  haveErrorResult = false;

  private subscribeHaveFileUpload: any;
  private subscribeHaveErrorResult: any;

  constructor(
    private dataService: DataService,
    public dialogRef: MatDialogRef<ImportCustomerFileComponent>,
    @Inject(MAT_DIALOG_DATA) public message: string
  ) {
  }

  ngOnInit() {
    this.subscribeHaveFileUpload = this.dataService.haveAttachFile.subscribe({
      next: (v) => {
        this.haveFileUpload = v;
      }
    });

    this.subscribeHaveErrorResult = this.dataService.haveErrorResult.subscribe({
      next: (v) => {
        this.haveErrorResult = v;
      }
    });

    this.dataService.imported.subscribe({
      next: (v) => {
        this.dialogRef.close();
      }
    });
  }

  ngOnDestroy() {
    this.subscribeHaveFileUpload.unsubscribe();
    this.subscribeHaveErrorResult.unsubscribe();
  }

  onUploadFileCustomer() {
    this.uploadFileComponent.uploadFile();
  }

  downFileTemplateExcelAddCustomer(e) {
    e.preventDefault();
    this.dataService.setDownFile(true);
  }

  onNoClick() {
    this.dialogRef.close();
  }

}
